
import { createHistoryEntry } from "../../api/historyService";
export const useCreateHistoryEntry = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createHistoryEntry(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create history entry", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};